import {GraphValues} from "./GraphValues";

export class Tempistiche {
    mediaRotazioneTavoli!: string;
    rotazioneList!: GraphValues[];
    mediaPermanenza!: string;
    tempoPermanenzaList!: GraphValues[];
    mediaPreparazione!: string;
    tempoPreparazioneList!: GraphValues[];
    mediaTempoPass!: string;
    tempoPassList!: GraphValues[];

    static fromJson(json: any): Tempistiche {
        let result = new Tempistiche();
        result.mediaRotazioneTavoli = json.mediaRotazioneTavoli;
        result.mediaPermanenza = json.mediaPermanenza;
        result.mediaPreparazione = json.mediaPreparazione;
        result.mediaTempoPass = json.mediaTempoPass;

        if (json.rotazioneList) {
            result.rotazioneList = json.rotazioneList.map((value: any) => GraphValues.fromJson(value));
        }

        if (json.tempoPermanenzaList) {
            result.tempoPermanenzaList = json.tempoPermanenzaList.map((value: any) => GraphValues.fromJson(value));
        }

        if (json.tempoPreparazioneList) {
            result.tempoPreparazioneList = json.tempoPreparazioneList.map((value: any) => GraphValues.fromJson(value));
        }

        if (json.tempoPassList) {
            result.tempoPassList = json.tempoPassList.map((value: any) => GraphValues.fromJson(value));
        }


        return result;
    }
}
